<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' @child-event='getTextVal' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


	<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 核价确认</Button>
	<Button class="submit-process" v-on:click='refuse' v-bind:loading="formLoading" size="large" type="primary"> 驳回
	</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {guid} from "../utils/tableDelete.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage,
		getFlowTemplate,
		GetPendingProcessById
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	const sendMessagetTemplate = {
	  title: null,
	  url: null,
	  toUser: [],
	  desc: null,
	  template: null,
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				applyTemplateData:null,
				sendMessageData:{},
				flowId:null
			}
		},
		created() {
			// stringUtils.setAddIsShow(false);
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.flowId = this.$route.query.flowId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
		},
		methods: { //方法
			clickChoose(dataVal, name) {
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values=[];
						dataVal.Values.push([depart.id,depart.name]);
						dataVal.Value = depart.name;
					}
				})
			},

			getTemplate: async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				var thar = this;
				
				// await GetPendingProcessById(this.flowId).then(response =>{
				// 	if(response.Body==null){
				// 		this.Message({
				// 			message: '该流程已经处理完成',
				// 			type: 'success',
				// 			duration: 3 * 1000
				// 		});
				// 		setTimeout(() => {
				// 			this.$router.push("/Pricing");
				// 		}, 1000)
				// 		return;
				// 	}
				// })
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					await thar.getFlowTemplateInfo();

					
					controls.TemplateContent.Controls.forEach(async (item,index) => {
						var departs = thar.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "请选择审批流程") {
							item.Disable=true;
							item.IsShow=false;
						}
						if (item.Property.Title[0].Text == "申请人员部门") {
							item.Disable=true;
							item.IsShow=false;
						}
						
						if (item.Property.Title[0].Text == "行政主任") {
							if(thar.applyTemplateData!=null){
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "行政主任"})[0].Values
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "关联申请单") {
							item.Value = thar.spNo;
						}
						
						if (item.Property.Title[0].Text == "行政经理") {
							if(thar.applyTemplateData!=null){
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "行政经理"})[0].Values
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "小战区区董") {
							if(thar.applyTemplateData!=null){
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "小战区区董"})[0].Values
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大战区区董") {
							if(thar.applyTemplateData!=null){
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "大战区区董"})[0].Values
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "经理/总监")
						{
							if(thar.applyTemplateData!=null){
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "经理/总监"})[0].Values
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "总经理") {
							if(thar.applyTemplateData!=null){
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "总经理"})[0].Values
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "维修") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								var control=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "维修"})[0];
								if(control!=null){
									item.Value=control.Value;
								}else{
									item.IsShow=false;
								}
							}
							
						}
						if (item.Property.Title[0].Text == "申请原因") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请原因"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "申请类别1") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请类别1"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "申请类别2") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请类别2"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "配送地点") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "配送地点"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "收货人联系方式") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "收货人联系方式"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "配送到位时间") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "配送到位时间"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "备注") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "备注"})[0].Value;
							}
						}

						if (item.Property.Title[0].Text == "合计") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "合计"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "申请人员") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								var empName=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "人员"})[0].Value;
								var empNo=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "工号"})[0].Value;
								item.Values=[[empNo,empName]];
								item.Value=empName;
							}
						}
						if (item.Property.Title[0].Text == "申请人工号") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "工号"})[0].Value;
							}
						}
						// if (item.Property.Title[0].Text == "申请人部门") {
						// 	item.Disable=true;
						// 	if(thar.applyTemplateData!=null){
						// 		item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0].Value;
						// 	}
						// }
						if (item.Property.Title[0].Text == "申请人职位") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "职位"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "申请人部门") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "申请部门") {
							item.Disable=true;
							if(thar.applyTemplateData!=null){
								item.Value=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请部门"})[0].Value;
								item.Values=thar.applyTemplateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请部门"})[0].Values;
							}
						}
						
						if (item.Property.Title[0].Text == "验收人员") {
							item.Disable=true;
							item.Value=thar.logInfo.EmpName;
						}
						if (item.Property.Title[0].Text == "验收人工号") {
							item.Disable=true;
							item.Value=thar.logInfo.EmpNo;
						}
						
						if (item.Property.Title[0].Text == "比价") {
							item.Config.Table.Children.forEach(e => {
								e.Disable = true;
							})
						}
						if (item.Property.Title[0].Text == "实付金额") {
							item.IsShow = false;
							item.Disable = true;
							item.Value =0;
						}
						if (item.Property.Title[0].Text == "验收物品信息") {
							item.IsShow = false;
							// item.addIsShow = true;
							thar.$set(item,'addIsShow',true);
						}
						if (item.Property.Title[0].Text == "超出申请金额") {
							item.IsShow = false;
							item.Value =0;
						}
						if (item.Property.Title[0].Text == "应退补款") {
							item.IsShow = false;
							item.Value =0;
						}
						if (item.Property.Title[0].Text == "采购金额说明情况") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "费用报销明细") {
							item.IsShow = false;
						}
						
						// if (item.Property.Title[0].Text == "核价人职位") {
						// 	item.Disable=true;
						// 	item.Value=thar.logInfo.PositionName;
						// }
						// if (item.Property.Title[0].Text == "核价人员") {
						// 	item.Disable=true;
						// 	item.Value=thar.logInfo.EmpName
						// }
					});
					
					
					
					
					
					// thar.templateData = await thar.assignControlBySpNo(controls, thar.spNo);
					// thar.templateData = thar.assignControl(controls, thar.logInfo);
					thar.templateData = thar.assignControl(controls, thar.logInfo);
					thar.templateData = await thar.assignControlBySpNo(controls, null, thar.flowId,true);
					thar.listLoading = false;
					
					//thar.templateData.TemplateContent.Controls[17].IsShow=true
					let val = "";
					if(thar.applyTemplateData!=null){
						thar.applyTemplateData.TemplateContent.Controls.forEach(e =>{
							if(e.Property.Title[0].Text == '请选择审批流程'){
								if(e.Value == "option-1600689940131"){
									val = "1";
								}else{
									val = "2";
								}
							}
						})
					}
					
					thar.templateData.TemplateContent.Controls.forEach(e =>{
						if(e.Property.Title[0].Text == '验收物品信息'){
							e.addIsShow = true;
						}
						if(e.Property.Title[0].Text.indexOf('物品信息')>-1 ){
							e.addIsShow = true;
							thar.$set(e,"addIsShow",false);
						}
						if(e.Property.Title[0].Text.indexOf('比价')>-1 ){
							e.addIsShow = true;
							thar.$set(e,"addIsShow",false);
						}
						if(e.Property.Title[0].Text == '请选择审批流程'){
							e.Config.Selector.Options.forEach(t =>{
								if(val == t.Value[0].Text){
									e.Value = t.Key;
								}
							})
						}
					})
				});
				
				// var controlCheckItemsttt = thar.templateData.TemplateContent.Controls.filter(item => item.Property.Title[0].Text.includes("验收物品信息") )
				// controlCheckItemsttt.forEach(e=>{
				// 	e.addIsShow = true;
				// })
				
			},
			getEmployeeRelation: async function() {
				await getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getFlowTemplateInfo: async function() {
				if(this.flowId==null||this.flowId==undefined||this.flowId.length<=0){
						return;
				}
				await getFlowTemplate(this.flowId).then(response => {
					this.applyTemplateData = response.Body;
				});
			},
			getTextVal(val, name) {
				if (name == "实付金额") {
					var controls = this.templateData.TemplateContent.Controls;
					var applyMoney = parseFloat(controls.filter(item => item.Property.Title[0].Text == "合计")[0].Value).toFixed(2);
					var sureMoney = parseFloat(val).toFixed(2);
					var money = sureMoney - applyMoney;
					if (money <= 0) {
						money = 0.00;
					}
					controls.filter(item => item.Property.Title[0].Text == "超出申请金额")[0].Value = money;
				}
			},
			getSelectorVal(val, name) {
				if(name=="采购金额与申请金额是否一致"){
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "是" && val.indexOf(item.Key) > -1;
						})[0];
						
					var control = controls.filter(item => item.Property.Title[0].Text == "验收物品信息")[0];
					var controlItems = controls.filter(item => item.Property.Title[0].Text.includes("物品信息") && !item.Property.Title[0].Text.includes("验收物品信息") );
					var controlItemsClone = JSON.parse(JSON.stringify(controlItems));
					var controlCheckItems = controls.filter(item => item.Property.Title[0].Text.includes("验收物品信息") )
					
					if (option != null) {
						control.IsShow = false;
						control.Property.Require = 1;
						control.Config.Table.Children.forEach(e => {
							if(e.Property.Title[0].Text != '标签' && e.Property.Title[0].Text != '备注'&& e.Property.Title[0].Text != '借款金额'){
								e.Property.Require = 0;
							}
							if( e.Property.Title[0].Text == '借款金额'){
								e.Property.Require = 0;
								e.IsShow = false;
							}
						})
						
						controlCheckItems.forEach(e=>{
							e.IsShow = false;
						});
						
						var controlConfirmSum = controls.filter(item => item.Property.Title[0].Text == "金额确认")[0];
						var controlTotal = controls.filter(item => item.Property.Title[0].Text == "合计")[0];
						controlConfirmSum.Value = controlTotal.Value;
					} else {
						
						control.IsShow = true;
						control.Property.Require = 0;
						control.Config.Table.Children.forEach(e => {
							if(e.Property.Title[0].Text != '标签' && e.Property.Title[0].Text != '备注'){
								e.Property.Require = 1;
							}
							if( e.Property.Title[0].Text == '借款金额'){
								e.IsShow = false;
								e.Property.Require = 0;
							}
						})
						
						var controlConfirmSum = controls.filter(item => item.Property.Title[0].Text == "金额确认")[0];
						controlConfirmSum.Value = '';
						//物品信息 复制到 验收物品信息
						
						if(controlCheckItems.length==1)
						{
							var controlCheckItem = controlCheckItems[0];
							controlCheckItem.IsShow=false;
							var controlCheckItemIndex = controls.indexOf(controlCheckItem);
							var currentIndex = controlCheckItemIndex+1;
							controls.splice(controlCheckItemIndex, 1);
							var controlCheckItemStr = JSON.stringify(controlCheckItem);
							var controlCheckItems=[],controlCheckItemClone;
							
							//遍历物品信息
							controlItemsClone.forEach(e=>{
								controlCheckItemClone = JSON.parse(controlCheckItemStr);
								controlCheckItemClone.Property.Title[0].Text="验收" + e.Property.Title[0].Text;
								controlCheckItemClone.IsShow=true;
								controlCheckItemClone.Property.Require = 1;
								controlCheckItemClone.addIsShow = true;
								//controlCheckItemClone.deleteIsShow = true;
								controlCheckItemClone.Property.Id = control.Property.Id;//"Table-"+guid();
								
								//复制
								var controlItemChildren1 = e.Config.Table.Children.filter(item => item.Property.Title[0].Text.includes("物品名称"))[0];
								var controlCheckItemChildren1 = controlCheckItemClone.Config.Table.Children.filter(item => item.Property.Title[0].Text.includes("物品名称") )[0];
								controlCheckItemChildren1.Value = controlItemChildren1.Value;
								controlCheckItemChildren1.Values = controlItemChildren1.Values;
								controlCheckItemChildren1.Property.Require = controlItemChildren1.Property.Require;
								
								var controlItemChildren3 = e.Config.Table.Children.filter(item => item.Property.Title[0].Text == "数量")[0];
								var controlCheckItemChildren3 = controlCheckItemClone.Config.Table.Children.filter(item => item.Property.Title[0].Text == "验收数量" )[0];
								controlCheckItemChildren3.Value = controlItemChildren3.Value;
								controlCheckItemChildren3.Values = controlItemChildren3.Values;
								controlCheckItemChildren3.Property.Require = controlItemChildren3.Property.Require;
								
								var controlItemChildren5 = e.Config.Table.Children.filter(item => item.Property.Title[0].Text == "品牌规格")[0];
								var controlCheckItemChildren5 = controlCheckItemClone.Config.Table.Children.filter(item => item.Property.Title[0].Text == "品牌规格")[0];
								controlCheckItemChildren5.Value = controlItemChildren5.Value;
								controlCheckItemChildren5.Values = controlItemChildren5.Values;
								controlCheckItemChildren5.Property.Require = controlItemChildren5.Property.Require;
								
								var controlItemChildren7 = e.Config.Table.Children.filter(item => item.Property.Title[0].Text == "单价")[0];
								var controlCheckItemChildren7 = controlCheckItemClone.Config.Table.Children.filter(item => item.Property.Title[0].Text == "验收单价")[0];
								controlCheckItemChildren7.Value = controlItemChildren7.Value;
								controlCheckItemChildren7.Values = controlItemChildren7.Values;
								controlCheckItemChildren7.Property.Require = controlItemChildren7.Property.Require;
								
								var controlItemChildren8 = e.Config.Table.Children.filter(item => item.Property.Title[0].Text == "小计")[0];
								var controlCheckItemChildren8 = controlCheckItemClone.Config.Table.Children.filter(item => item.Property.Title[0].Text == "验收小计")[0];
								controlCheckItemChildren8.Value = controlItemChildren8.Value;
								controlCheckItemChildren8.Values = controlItemChildren8.Values;
								controlCheckItemChildren8.Property.Require = controlItemChildren8.Property.Require;
								
								var controlCheckItemChildren9 = controlCheckItemClone.Config.Table.Children.filter(item => item.Property.Title[0].Text == "是否借款")[0];
								controlCheckItemChildren9.Property.Require = 1;
								
								var controlCheckItemChildren10 = controlCheckItemClone.Config.Table.Children.filter(item => item.Property.Title[0].Text == "借款金额")[0];
								controlCheckItemChildren10.IsShow = false;
								controlCheckItemChildren10.Property.Require=0;
								
								
								this.$set(controlCheckItemClone,"addIsShow",true);
								controls.splice(currentIndex, 0, controlCheckItemClone);
								currentIndex++;
							})
							
							//end 物品信息 复制到 验收物品信息
						}else{
							var isShow = true;
							controlCheckItems.forEach(e=>{
								e.IsShow = isShow;
								isShow = true;//第二条开始 显示
							});
						}
						
						// var controlCheckItemsttt = controls.filter(item => item.Property.Title[0].Text.includes("验收物品信息") )
						// controlCheckItemsttt.forEach(e=>{
						// 	e.addIsShow = true;
						// })
					}
					controls.forEach(item => {
						if(item.Property.Title[0].Text == "实付金额"){
							item.IsShow = control.IsShow;
							item.Property.Require = control.IsShow?1:0;
							item.Value = control.IsShow?"":0;
						}
						if(item.Property.Title[0].Text == "应退补款"){
							item.IsShow = control.IsShow;
							item.Property.Require = control.IsShow?1:0;
							item.Value = control.IsShow?"":0;
						}
						if(item.Property.Title[0].Text == "采购金额说明情况"){
							item.IsShow = control.IsShow;
							item.Value = "";
						}
					});
				}
			},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			refuse(){
				var controls = this.templateData.TemplateContent.Controls;
				var applyEmpNo = '';
				controls.forEach(e =>{
					if (e.Property.Title[0].Text == "申请人工号") {
						applyEmpNo = e.Value;
					}
				})
				this.sendMessageData.Template=this.templateData;
				this.sendMessageData.Title="IT设备采购验收申请";
				this.sendMessageData.ToUser= [applyEmpNo];
				this.sendMessageData.Desc="驳回人员："+this.logInfo.EmpName;
				this.sendMessageData.Url=document.location.hostname+"/ITSBCGSQ?templateId=3TmB9gbrJq4y6pxNaUsjkEpPE55QMo9QCn5LGqjj&flowId="+this.flowId;
				//提交
				sendMessage(this.templateId, this.logInfo.EmpNo, this.spNo, this.sendMessageData,2,"",this.flowId).then(response => {
					this.Message({
						message: '驳回成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
				});
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.listLoading = true;
				var controls = this.templateData.TemplateContent.Controls;
				this.templateData.TemplateContent.Controls.forEach(e =>{
					if(e.Property.Title[0].Text == '采购金额与申请金额是否一致'){
						e.Config.Selector.Options.forEach( option => {
							if(option.Key == e.Value&&option.Value[0].Text == '是'){
								for(var i = controls.length-1; i>=0;i-- ){
									if(controls[i].Property.Title[0].Text.indexOf("验收物品信息")>-1){
										controls.splice(i,1);
									}
									if(controls[i].Property.Title[0].Text.indexOf("实付金额")>-1){
										controls.splice(i,1);
									}
									if(controls[i].Property.Title[0].Text.indexOf("应退补款")>-1){
										controls.splice(i,1);
									}
									if(controls[i].Property.Title[0].Text.indexOf("超出申请金额")>-1){
										controls[i].Value = "0";
									}
								}
							}
						})
					}
					if(e.Property.Title[0].Text == '验收物品信息'){
						let isOk = "";
						var childrens = e.Config.Table.Children;
						for(var j =childrens.length-1;j>=0;j--){
							let children = childrens[j];
							if(children.Property.Title[0].Text == '是否借款'){
								children.Config.Selector.Options.forEach(option =>{
									if(option.Key == children.Value){
										isOk = option.Value[0].Text
									}
								})
							}
							if(children.Property.Title[0].Text == '借款金额'){
								if(isOk == '否'){
									childrens.splice(j,1);
								}
							}
						}
					}
					if(e.Property.Title[0].Text == '费用报销明细'){
						e.IsShow = true;
					}
				})
				
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请人员"})[0];
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请人部门"})[0];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请人："+control1.Value+" 申请人部门："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control4=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "合计"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"总金额："+control4.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				this.templateData.SummaryList=SummaryList;
				
				var empNo = '';
				this.templateData.TemplateContent.Controls.forEach(e=>{
					if(e.Property.Title[0].Text == "申请人工号"){
						empNo = e.Value;
					}
				})
				
				//提交
				submitProcess(this.templateId, empNo, this.spNo, this.templateData,this.flowId).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/Pricing");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
					this.templateData.TemplateContent.Controls.forEach(e =>{
						if(e.Property.Title[0].Text == '费用报销明细'){
							e.IsShow = false;
						}
					})
				});
			}
		}

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
